import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import './Error.scss'

const CLASS = 'insights-portal-editor-error'

const Error = props => {
  const className = props.className || CLASS

  const editor = useMemo(() => props.editor || {}, [props.editor])

  const selectedErrors = useMemo(() => editor.errors?.title || [], [editor.errors?.title])

  return selectedErrors.length ? <div className={className}>{selectedErrors.join(' ')}</div> : null
}

Error.propTypes = {
  className: PropTypes.string,
  editor: PropTypes.object
}

export default Error
